<template>
  <div>
    <!--导航-->
    <div class="topNav" v-if="showNav">
          <span style="font-size: 18px; position: absolute; left: 5px;" @click="returnPage">
            <van-icon name="arrow-left"/>
          </span>
    </div>
    <!--错误页面-->
    <div class='errorArea'>
      <img src="../../assets/img/chat-bot.png" class="errorImg">
      <p class="errorMsg">{{ msg }}</p>
    </div>
  </div>
</template>

<script>
import {getConfig} from '../../util/auth'

export default {
  name: 'error',
  data () {
    return {
      showNav: false, // 是否展示导航栏
      msg: ''
    }
  },
  methods: {
    // 获取错误消息
    getErrorMsg () {
      this.msg = this.$route.query.msg
    },
    // 是否展示返回按钮
    getConfigInfoFn () {
      let configInfo = getConfig()
      if (configInfo) {
        this.showNav = configInfo.setting.settingsShowNavigationBar
      }
    },
    // 返回
    returnPage () {
      this.$router.push({
        name: 'login'
      })
    }
  },
  mounted () {
    // 获取错误消息
    this.getErrorMsg()
    // 是否展示返回按钮
    this.getConfigInfoFn()
  }
}
</script>

<style scoped>
.errorArea {
  width: 100%;
  height: 200px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.errorImg {
  width: 18%;
  margin-bottom: 25px;
}

.errorMsg {
  width: 40%;
  font-size: 15px;
  text-align: center;
  margin: 0 auto;
  color: #707070;
}

.topNav {
  position: fixed;
  top: 0;
  z-index: 99999;
  background: #fff;
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/chat/error.vue